module.exports = __webpack_public_path__ + "img/PDPA-7.2b3c5e5d.png";